import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { Major } from '../../../../api/types/settings/studies/major';
import { getCleanUserDetailsValuesOperation } from './get-clean-user-details-values-operation';
import { UserType } from '../../../../api/types/user/user-type';
import globalSettingsBranches from '../../../../stores/global-settings-branches';

export interface AdvanceSearchUserDetails {
  firstName?: string;
  lastName?: string;
  nationalId?: string;
  mail?: string;
  phoneNumber?: string;
}

export const advanceSearchOperation = async (
  userRole: UserType | undefined,
  offset: number,
  limit: number,
  setUsers: (advanceSearch: UserSummaryType[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
  firstName?: string,
  userDetails?: AdvanceSearchUserDetails,
  majorsIds?: number[],
  abstractCousresIds?: number[],
  abstractProgramIds?: number[],
  programStartYear?: number,
  branchIds?: number[],
) => {
  try {
    setLoading(true);

    const userDetailsCleanVlaues =
      getCleanUserDetailsValuesOperation(userDetails);

    const finalBranchIds =
      branchIds && branchIds.length > 0
        ? branchIds
        : globalSettingsBranches.branches.map((item) => item.id);

    const advanceSearchRes = await appApi.getAdvanceSearch(
      userRole,
      offset,
      limit,
      firstName,
      userDetailsCleanVlaues,
      majorsIds,
      abstractCousresIds,
      abstractProgramIds,
      programStartYear,
      finalBranchIds,
    );

    const paginationResponse = advanceSearchRes.data.body;

    // Ensure we have valid pagination response
    if (!paginationResponse) {
      setUsers([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    if (!Array.isArray(paginationResponse.data)) {
      console.error('Invalid data in pagination response:', paginationResponse);
      setUsers([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setUsers(paginationResponse.data);
    const totalCount = paginationResponse.total ?? 0;
    setTotal(totalCount);
    console.log('Setting total to:', totalCount);
    setLoading(false);
  } catch (e) {
    toast.error('החיפוש מתקדם נכשל, נסה שוב בעוד מספר רגעים...');
    setLoading(false);
  }
};
